import { autoinject } from "aurelia-framework";
import { UserClientService } from "../basic/user-client.service";
import { DialogClientService } from "../basic/dialog-client.service";
import { ConfigService } from "../basic/config.service";
import { UserModel } from "../../models/user.models";

@autoinject
export class GoogleAnalyticsService {
    
    private _googleAnalytics4Code: string;
    constructor(private userClientService: UserClientService, private dialogClientService: DialogClientService,
        private configService: ConfigService) {
        this._googleAnalytics4Code = this.configService.config.analytics?.googleAnalytics?.analyticsApiKey
        
        window['dataLayer'] = window['dataLayer'] || [];
        // eslint-disable-next-line prefer-rest-params
        window['ga4tag'] = function gtag() { window['dataLayer'].push(arguments); } //Don't use ...arg as it will break the function 
    }

    private beginGA4Audit(email?: string) {
            
        if (!this.isGA4Initialized()) return;
        
        window['ga4tag']('js', new Date());
        window['ga4tag']('config', this._googleAnalytics4Code);
        if (this.userClientService.currentUser) {
            this.setAllGA4Dimensions(this.userClientService.currentUser);
        } 
        else {
            this.setAllGA4DimensionsAnonymously(email);
        }
    }
      
    //Where category is the event name and action is any extra detail
    public sendCustomGA4Event(category: string, action: string = null) {       
        this.sendCustomGA4EventMulti(category, {'action' : action})
    }

    //Where category is the event name and action is any extra detail
    public sendCustomGA4EventMulti(category: string, dimensions: any) {       
        if (!this.isGA4Initialized()) return;
        if (this.userClientService.currentUser) {
            this.beginGA4Audit();
            dimensions['dialog'] = this.getDialogName()
            dimensions['send_to'] = this._googleAnalytics4Code;
            window['ga4tag']('event', category, dimensions);
        }
    }

    //Where category is the event name and action is any extra detail
    public sendCustomGA4EventMultiAnonymously(category: string, dimensions: any, email: string) {       
        if (!this.isGA4Initialized()) return;
        if(email) {
            this.beginGA4Audit(email);
            dimensions['dialog'] = this.getDialogName()
            dimensions['send_to'] = this._googleAnalytics4Code;
            window['ga4tag']('event', category, dimensions);
        }
    }
    
    //Set all GA4 dimensions
    private setAllGA4Dimensions(currentUser: UserModel) {
        let businessUnitId = null;
        let customerId = null;
        let customerName = null;
        let businessUnitName = null;
        let companyId = null;
        let company = null;
        let username = null;
        let username_extra = null;
        if (currentUser && currentUser.userCompanyAssociations && currentUser.userCompanyAssociations.length > 0) {
            company = currentUser.userCompanyAssociations[0].companyName;
            companyId = currentUser.userCompanyAssociations[0].companyId
        }
        if (currentUser && currentUser.businessUnit) {                           
            businessUnitId = currentUser.businessUnit.businessUnitId;
            customerId = currentUser.businessUnit.customerId;
            customerName = currentUser.businessUnit.customerName;
            businessUnitName = currentUser.businessUnit.businessUnitName;
        }
        else {
            businessUnitId = 0;
            customerId = 0;
            customerName = 'Rightship Internal';
            businessUnitName = 'Rightship Internal';
        }
        username = currentUser.user.email;
        if(username.length > 36) {
            username_extra = username.substring(36)
            username = username.substring(0, 36)
        }
        window['ga4tag']('set','user_properties', {
            'userId': currentUser.user.id,
            'username': username,
            'username_extra': username_extra ?? "",
            'customerId': customerId,
            'customerName': customerName,
            'businessUnitId': businessUnitId,
            'businessUnitName': businessUnitName,
            'companyId': companyId,
            'companyName': company,
            'roleId': currentUser.user.roleUsers[0].roleId,
            'roleName': currentUser.user.roleUsers[0].roleName,
            'appEnvironment': this.configService.config.environment,
            'rsApplication': this.configService.config.name ? this.configService.config.name : 'Unknown'
        })
    }
    
    //Set all GA4 dimensions for Anonymous users
    private setAllGA4DimensionsAnonymously(email: string) {
        let username = null;
        let username_extra = null;

        username = email;
        if(email.length > 36) {
            username_extra = email.substring(36)
            username = email.substring(0, 36)
        }
        window['ga4tag']('set','user_properties', {
            'username': username,
            'username_extra': username_extra ?? "",
            'appEnvironment': this.configService.config.environment,
            'rsApplication': this.configService.config.name ? this.configService.config.name : 'Unknown'
        })
    }
    
    private isGA4Initialized() {
        return (Boolean)(window && window['ga4tag'] && this._googleAnalytics4Code);
    }
    private getDialogName() {
        return this.dialogClientService.isModalVisible ? this.dialogClientService.view : '';
    }
}